// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1NXM-","description":"PatientConsentPreview_description__3otKm"};